import { render, staticRenderFns } from "./ResetConfirmPhone.vue?vue&type=template&id=11aa3ca0&lang=pug&"
import script from "./ResetConfirmPhone.vue?vue&type=script&lang=js&"
export * from "./ResetConfirmPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports